/* eslint-disable max-lines */
import { createUrl } from '../_clean-code/utils/urlHelper';

const apis = {
  login(data) {
    return {
      method: 'POST',
      url: '/identity/login',
      data
    };
  },
  logout() {
    return {
      method: 'POST',
      url: '/identity/logout'
    };
  },
  register(data) {
    return {
      method: 'POST',
      url: '/identity/register',
      data
    };
  },
  getUserProfile() {
    return {
      method: 'GET',
      url: '/identity/me'
    };
  },
  fetchUsersList(params) {
    return {
      method: 'GET',
      url: `/identities/users?${
        params?.isCorporation ? 'isCorporation=true' : ''
      }`
    };
  },
  fetchOperatorsList() {
    return {
      method: 'GET',
      url: '/identities/operators'
    };
  },
  forgotPassword(data) {
    return {
      method: 'POST',
      url: '/identity/forgotPassword',
      data
    };
  },
  resetPassword(data) {
    return {
      method: 'POST',
      url: '/identity/resetPassword',
      data
    };
  },
  inviteUser(data) {
    return {
      method: 'POST',
      url: '/identity/invite',
      data
    };
  },
  resendUserInvite(data) {
    return {
      method: 'POST',
      url: '/identity/invite/resend',
      data
    };
  },
  deleteUser(data) {
    return {
      method: 'POST',
      url: '/identity/remove',
      data
    };
  },
  deleteOperator({ id }) {
    return {
      method: 'DELETE',
      url: `/identities/operators/${id}`
    };
  },
  updateUser(data) {
    return {
      method: 'PUT',
      url: '/identity/user',
      data
    };
  },
  updateOperator(params) {
    return {
      method: 'PATCH',
      url: `/identities/operators/${params.id}`,
      data: params.data
    };
  },
  createUser(data) {
    return {
      method: 'POST',
      url: '/identity/create-user',
      data
    };
  },
  createOperator(data) {
    return {
      method: 'POST',
      url: '/identities/operators',
      data
    };
  },
  bulkDeleteOperators(data) {
    return {
      method: 'DELETE',
      url: `/identities/operators`,
      data
    };
  },
  getNotifications() {
    return {
      method: 'GET',
      url: '/notification/me'
    };
  },
  dismissNotification(id) {
    return {
      method: 'PATCH',
      url: `/notification/dismiss/${id}`
    };
  },
  readNotifications(ids) {
    return {
      method: 'PATCH',
      url: '/notification/read/bulk',
      data: {
        ids
      }
    };
  },
  saveAllTranslations(data) {
    return {
      method: 'POST',
      url: 'translation/save/all',
      data
    };
  },
  updateTranslation(data) {
    return {
      method: 'POST',
      url: 'translation/lang/update',
      data
    };
  },
  removeTranslation(lang) {
    return {
      method: 'DELETE',
      url: `translation/${lang}`
    };
  },
  updateTranslationByKey({ lang, ...data }) {
    return {
      method: 'PATCH',
      url: `translation/${lang}`,
      data
    };
  },
  getMachines(data) {
    return {
      method: 'GET',
      url: '/machine/list',
      data
    };
  },
  setMachineExternalNames(data) {
    return {
      method: 'PATCH',
      url: '/machines/external-name',
      data
    };
  },
  getCustomShifts({ shiftScheduleId, startDateTime, endDateTime }) {
    return {
      method: 'GET',
      url: `/schedule/${shiftScheduleId}/get-custom-shifts?startDateTime=${startDateTime}&endDateTime=${endDateTime}`
    };
  },
  getAlerts(data) {
    return {
      method: 'GET',
      url: '/alert/list',
      data
    };
  },
  updateAlerts(data) {
    return {
      method: 'POST',
      url: `/alert/update`,
      data
    };
  },

  getMachineShifts() {
    return {
      method: 'GET',
      url: '/v2/shifts'
    };
  },

  getMachineStops({ machineIds, ...data }) {
    return {
      method: 'GET',
      url: createUrl('/v2/stops')
        .addQueryParamMany('machineIds[]', machineIds)
        .toStringUrl(),
      data
    };
  },

  splitMachineStops(data) {
    return {
      method: 'POST',
      url: `/v2/stops/split`,
      data
    };
  },

  getMachineStopCauses() {
    return {
      method: 'GET',
      url: `/v2/stops/causesNew`
    };
  },

  getTreeLosses() {
    return {
      method: 'GET',
      url: `/v2/stops/lossTrees`
    };
  },
  updateTreeLoss({ data }) {
    return {
      method: 'POST',
      url: '/v2/stops/lossTrees',
      data: { lossTree: data }
    };
  },
  deleteTreeLoss({ id }) {
    return {
      method: 'DELETE',
      url: `/v2/stops/lossTrees/${id}`
    };
  },
  updateTreeLossMachine({ id, machineId }) {
    return {
      method: 'PUT',
      url: `/v2/stops/lossTrees/${id}/machine/${machineId}`
    };
  },
  deleteTreeLossMachine({ id, machineId }) {
    return {
      method: 'DELETE',
      url: `/v2/stops/lossTrees/${id}/machine/${machineId}`
    };
  },
  getCompanySummary() {
    return {
      method: 'GET',
      url: `/v2/stops/company/summary`
    };
  },

  getStopMachineGroups() {
    return {
      method: 'GET',
      url: `/v2/stops/machine-groups`
    };
  },

  getMachineGroups() {
    return {
      method: 'GET',
      url: `/v2/stops/machine/machine-groups`
    };
  },
  getShiftIndicators(data) {
    return {
      method: 'GET',
      url: `/v2/shifts/indicators`,
      data
    };
  },
  postExcludeShifts(data) {
    return { method: 'POST', url: '/v2/shifts/exclude', data };
  },

  getStopSettings(data) {
    return {
      method: 'GET',
      url: `/v2/stops/stop-settings`,
      data
    };
  },

  createGeneralCause(data) {
    return { method: 'POST', url: '/v2/stops/general-causes', data };
  },

  createBulkGeneralCauses(data) {
    return { method: 'POST', url: '/v2/stops/bulk/general-causes', data };
  },

  deleteGeneralCause(data) {
    return { method: 'DELETE', url: '/v2/stops/general-causes', data };
  },

  createSpecificCause(data) {
    return { method: 'POST', url: '/v2/stops/specific-causes', data };
  },

  createBulkSpecificCauses(data) {
    return { method: 'POST', url: '/v2/stops/bulk/specific-causes', data };
  },

  deleteSpecificCause(data) {
    return { method: 'DELETE', url: '/v2/stops/specific-causes', data };
  },

  createComponent(data) {
    return { method: 'POST', url: '/v2/stops/components', data };
  },
  deleteComponent(data) {
    return { method: 'DELETE', url: '/v2/stops/components', data };
  },

  getAlertSettingsV3() {
    return {
      method: 'GET',
      url: `/v3/alert-settings`
    };
  },
  createAlertSettingV3(data) {
    return {
      method: 'PUT',
      url: '/v3/alert-settings',
      data: {
        ...data,
        priority: data.priority || 2
      }
    };
  },
  deleteAlertSettingV3({ id }) {
    return {
      method: 'DELETE',
      url: `/v3/alert-settings`,
      data: { id }
    };
  },
  updateAlertSettingV3(data) {
    return {
      method: 'PATCH',
      url: '/v3/alert-settings',
      data: {
        ...data,
        priority: data.priority || 2
      }
    };
  },
  getAlertSettings() {
    return {
      method: 'GET',
      url: `/v2/alert-settings/all`
    };
  },
  createAlertSetting(data) {
    return {
      method: 'PUT',
      url: '/v2/alert-settings/new',
      data
    };
  },
  deleteAlertSetting({ id }) {
    return {
      method: 'DELETE',
      url: `/v2/alert-settings/delete/${id}`
    };
  },
  updateAlertSetting(data) {
    return {
      method: 'PATCH',
      url: '/v2/alert-settings/update',
      data
    };
  },
  getAlertPersonas() {
    return {
      method: 'GET',
      url: `/v2/alert-settings/persona/all`
    };
  },
  createAlertPersona(data) {
    return {
      method: 'PUT',
      url: '/v2/alert-settings/persona/new',
      data
    };
  },
  deleteAlertPersona({ id }) {
    return {
      method: 'DELETE',
      url: `/v2/alert-settings/delete/persona/${id}`
    };
  },
  updateAlertPersona(data) {
    return {
      method: 'PATCH',
      url: '/v2/alert-settings/update/alertPersona',
      data
    };
  },
  updateAlertPersonaRecipient(data) {
    return {
      method: 'PATCH',
      url: '/v2/alert-settings/update/alertRecipient',
      data
    };
  },
  getIdleShiftsFlag() {
    return {
      method: 'GET',
      url: `/v2/shifts/company-flag`
    };
  },
  updateIdleShiftsFlag(data) {
    return {
      method: 'PUT',
      url: '/v2/shifts/company-flag',
      data
    };
  },
  getMachineEquipments() {
    return {
      method: 'GET',
      url: `/v2/stops/causesNew`
    };
  },
  updateMachineEquipments(data) {
    return {
      method: 'PATCH',
      url: '/v2/stops/machine-components',
      data
    };
  },
  createBulkEquipments(data) {
    return { method: 'POST', url: '/v2/stops/bulk/equipments', data };
  },
  getMachineStatus(machineIds) {
    return {
      method: 'GET',
      url: createUrl('/machines/status')
        .addQueryParamMany('id', machineIds)
        .toStringUrl()
    };
  },
  getMachineWorkingReportByRange(params) {
    return {
      method: 'GET',
      url: createUrl('/machines/availability')
        .addQueryParam('range', params.range)
        .addQueryParamMany('machineIds', params.machineIds)
        .toStringUrl()
    };
  },
  getMainDashboardGeneralCausesByRange(params) {
    return {
      method: 'GET',
      url: createUrl('/v2/stopsClasification/get-general-causes-report')
        .addQueryParam('range', params.range)
        .addQueryParamMany('machineIds', params.machineIds)
        .toStringUrl()
    };
  },
  getMainDashboardDeclaredStopsByRange(params) {
    return {
      method: 'GET',
      url: createUrl('/v2/stopsClasification/declared-stops')
        .addQueryParam('range', params.range)
        .addQueryParamMany('machineIds', params.machineIds)
        .toStringUrl()
    };
  },
  createStopAutomation(data) {
    return { method: 'PUT', url: '/v2/stops/stop-automation', data };
  },
  updateStopAutomation(data) {
    return { method: 'PATCH', url: '/v2/stops/stop-automation', data };
  },
  deleteStopAutomation({ data }) {
    return { method: 'DELETE', url: '/v2/stops/stop-automation', data };
  },
  getStopAutomations() {
    return {
      method: 'GET',
      url: `/v2/stops/stop-automation`
    };
  },
  getMachinesGroup() {
    return {
      method: 'GET',
      url: `/v2/machines-group`
    };
  },
  createMachinesGroup(data) {
    return {
      method: 'POST',
      url: '/v2/machines-group',
      data
    };
  },
  deleteMachinesGroup(data) {
    return {
      method: 'DELETE',
      url: '/v2/machines-group',
      data
    };
  },
  updateMachinesGroup(data) {
    return {
      method: 'PATCH',
      url: '/v2/machines-group',
      data
    };
  },
  getAssignedMachinesGroupForUser(id) {
    return {
      method: 'GET',
      url: `/v2/machines-group/user/${id}`
    };
  },
  addMachinesGroupToUser(data) {
    return {
      method: 'PUT',
      url: '/v2/machines-group/add/user',
      data
    };
  },
  getMachineRealTime({ machineId, currentTimestamp }) {
    return {
      method: 'GET',
      url: `/machine-status/real-time?id=${machineId}&timestamp=${currentTimestamp}`
    };
  },
  getCompanyUIConfig() {
    return {
      method: 'GET',
      url: `/config/user`
    };
  },
  updateCompanyUIConfig(data) {
    return {
      method: 'PUT',
      url: `/config`,
      data
    };
  },
  getHistoricalData({ machineIds, ...data }) {
    return {
      method: 'GET',
      url: createUrl('/machines/historical')
        .addQueryParamMany('machineId', machineIds)
        .toStringUrl(),
      data
    };
  },
  getSkus() {
    return {
      method: 'GET',
      url: `/skus`
    };
  },
  createSkus(data) {
    return {
      method: 'POST',
      url: '/skus/bulk',
      data
    };
  },
  createSkuWithNominalSpeed(data) {
    return {
      method: 'POST',
      url: '/speed/bulk/sku',
      data
    };
  },
  bulkDeleteSkus(data) {
    return {
      method: 'DELETE',
      url: '/skus',
      data
    };
  },
  deleteSkus(params) {
    return {
      method: 'DELETE',
      url: `/skus/${params.skuId}`
    };
  },
  updateSkus(params) {
    return {
      method: 'PATCH',
      url: `/skus/${params.skuId}`,
      data: params.data
    };
  },
  updateSkuWithNominalSpeed(data) {
    return {
      method: 'PATCH',
      url: `/speed/bulk/sku`,
      data
    };
  },
  getWorkOrderByMachines(params) {
    return {
      method: 'GET',
      url: createUrl('/work-orders')
        .addQueryParam('machines', params.machineId)
        .toStringUrl()
    };
  },
  //TODO: use this when loading dropdowns
  getWorkOrderTarget() {
    return {
      method: 'GET',
      url: '/work-orders'
    };
  },
  getWorkOrderTargetWithPagination(params) {
    const _url = createUrl(`/work-orders`)
      .addQueryParam('page', (params.page - 1).toString())
      .addQueryParam('view', 'detailWithTotalItems')
      .addQueryParam('pageSize', params.pageSize);

    if (params.includeNoMachine) {
      _url.addQueryParam('includeNoMachine', params.includeNoMachine);
    }
    if (params.machineIds && params.machineIds.length > 0) {
      _url.addQueryParamMany('machines', params.machineIds);
    }
    if (params.status && params.status.length > 0) {
      _url.addQueryParamMany('status', params.status);
    }
    if (params.id && params.id.length > 0) {
      _url.addQueryParamMany('id', params.id);
    }

    return {
      method: 'GET',
      url: _url.toStringUrl()
    };
  },
  createWorkOrder(data) {
    return {
      method: 'POST',
      url: '/work-orders',
      data
    };
  },
  createWorkOrderTargets(data) {
    return {
      method: 'POST',
      url: '/work-order-target',
      data
    };
  },
  importWorkOrders(data) {
    return {
      method: 'POST',
      url: '/work-orders/import',
      data
    };
  },
  bulkCreateWorkOrders(data) {
    return {
      method: 'POST',
      url: '/work-orders/bulk',
      data
    };
  },
  bulkDeleteWorkOrders(data) {
    return {
      method: 'DELETE',
      url: '/work-orders',
      data
    };
  },
  deleteWorkOrders(params) {
    return {
      method: 'DELETE',
      url: `/work-orders/${params.workOrderId}`
    };
  },
  updateWorkOrders(data) {
    return {
      method: 'PUT',
      url: `/work-order-target`,
      data
    };
  },
  getNominalSpeeds() {
    return {
      method: 'GET',
      url: '/speed'
    };
  },
  createNominalSpeed(data) {
    return {
      method: 'POST',
      url: '/speed',
      data
    };
  },
  deleteNominalSpeed(params) {
    return {
      method: 'DELETE',
      url: `/speed/${params.id}`
    };
  },
  updateNominalSpeed(params) {
    return {
      method: 'PATCH',
      url: `/speed/${params.id}`,
      data: params.data
    };
  },
  bulkCreateNominalSpeeds(data) {
    return {
      method: 'POST',
      url: '/speed/bulk',
      data
    };
  },
  bulkDeleteNominalSpeeds(data) {
    return {
      method: 'DELETE',
      url: '/speed',
      data
    };
  },
  getWork() {
    return {
      method: 'GET',
      url: '/work-orders'
    };
  },
  updateWorkOrderStatus(params) {
    return {
      method: 'PUT',
      url: `/work-orders/${params.id}`,
      data: params.data
    };
  },
  getSkusByWorkOrder(params) {
    return {
      method: 'GET',
      url: `/work-orders/progress/${params.id}`
    };
  },
  getQualities() {
    return {
      method: 'GET',
      url: '/quality-issues'
    };
  },
  createQualities(data) {
    return {
      method: 'POST',
      url: '/quality-issues/bulk',
      data
    };
  },
  deleteQualities(params) {
    return {
      method: 'DELETE',
      url: `/quality-issues/bulk?${params.qualityIds.reduce(
        (acc, curr, i) =>
          i < params.qualityIds.length - 1
            ? `${acc}id=${curr}&`
            : `${acc}id=${curr}`,
        ''
      )}`
    };
  },
  updateQuality(params) {
    return {
      method: 'PUT',
      url: `/quality-issues/${params.qualityId}`,
      data: params.data
    };
  },
  createNominalSpeedWithMultipleMachines(data) {
    return {
      method: 'POST',
      url: '/speed/bulk/machines',
      data
    };
  },
  getWorkOrderExportData(data) {
    return {
      method: 'GET',
      url: `/work-orders/export?denormalized=${data.isDenormalized}`,
      data
    };
  },
  getRawMaterials() {
    return {
      method: 'GET',
      url: `/raw-materials`
    };
  },
  getAllReportsSubscription({ lang }) {
    return {
      method: 'GET',
      url: `/subscriptions?lang=${lang}`
    };
  },
  getReportSubscriptionDetail({ lang, id }) {
    return {
      method: 'GET',
      url: `/subscriptions/${id}?lang=${lang}`
    };
  },
  getReportSubscriptionLogs({ id }) {
    return {
      method: 'GET',
      url: `/subscriptions/${id}/logs`
    };
  },
  deleteReportSubscription({ id, lang }) {
    return {
      method: 'DELETE',
      url: `/subscriptions/${id}?lang=${lang}`
    };
  },
  downloadReportInstance({ reportSubscriptionId, instanceId }) {
    return {
      method: 'GET',
      url: `/subscriptions/${reportSubscriptionId}/logs/${instanceId}/download`
    };
  },
  cancelReportInstance({ reportSubscriptionId, instanceId }) {
    return {
      method: 'POST',
      url: `/subscriptions/${reportSubscriptionId}/logs/${instanceId}/cancel`
    };
  },
  getReportDashboards({ lang }) {
    return {
      method: 'GET',
      url: `/subscriptions/dashboards?lang=${lang}`
    };
  },
  getReportGroupedDashboards({ lang }) {
    return {
      method: 'GET',
      url: `/subscriptions/dashboards/grouped?lang=${lang}`
    };
  },
  createReportSubscription(data) {
    return {
      method: 'POST',
      url: '/subscriptions',
      data
    };
  },
  updateReportSubscription(data) {
    return {
      method: 'PATCH',
      url: `/subscriptions/${data.id}`,
      data
    };
  },
  sendReportToRecipients(data) {
    return {
      method: 'POST',
      url: `/subscriptions/${data.id}/send`,
      data
    };
  },
  reorderSubscriptionDashboards(data) {
    return {
      method: 'PATCH',
      url: `/subscriptions/${data.id}/order`,
      data
    };
  },
  getCompanyAnalyticsCharts(params) {
    return {
      method: 'GET',
      url: `/subscriptions/dashboards/grouped?lang=${params.lang}`
    };
  },
  fetchWorkOrderName({ code, pageSize }) {
    return {
      method: 'GET',
      url: `/work-orders/search?code=${code}&pageSize=${pageSize}`
    };
  },
  fetchSimpleWorkOrderName({ code, pageSize }) {
    return {
      method: 'GET',
      url: `/simple-work-orders/search?name=${code}&pageSize=${pageSize}`
    };
  },
  fetchSettingsForProduction() {
    return {
      method: 'GET',
      url: `/configuration`
    };
  },
  updateSettingsForProduction(data) {
    return {
      method: 'PATCH',
      url: `/configuration`,
      data
    };
  },
  fetchRealtimeDetail(machineId) {
    return {
      method: 'GET',
      url: `/machines/realtime/detail/${machineId}`
    };
  },
  fetchRawMaterials() {
    return {
      method: 'GET',
      url: `/raw-materials`
    };
  }
};

export default apis;

// searchByName: async function (code: string, pageSize: number) {
//   const response = await apiClient.request(
//     'GET',
//     `/work-orders/search?code=${code}&pageSize=${pageSize}`
//   );
//   return response as SearchByNameResponseType;
// }
